import { useI18n } from "@/lib/i18n";
import {
  Radar, Bluetooth, Car, SmartphoneCharging, MapPin, ScanLine, Camera, BellRing,
  CreditCard, Mic, Watch, Smartphone, Users, Share2, Siren, WifiOff, Compass,
  Move3d, Building2, Signal, Radio, Zap, Gauge, Cpu,
} from "lucide-react";

const ICONS = [
  Radar, Bluetooth, Car, SmartphoneCharging, MapPin, ScanLine, Camera, BellRing,
  CreditCard, Mic, Watch, Smartphone, Users, Share2, Siren, WifiOff, Compass,
  Move3d, Building2, Signal, Radio, Zap, Gauge, Cpu,
];

const TAG_STYLES = {
  now: "bg-brand-greenSoft text-brand-green border-brand-green/20",
  planned: "bg-brand-goldSoft text-brand-charcoal border-brand-gold/30",
  soon: "bg-brand-sand text-brand-charcoal/70 border-brand-line",
  future: "bg-brand-charcoal text-brand-gold border-brand-gold/40",
};

export default function SmartFeatures() {
  const { t } = useI18n();
  const items = t("smart.items");
  const labels = t("smart.labels");

  return (
    <section id="features" className="section bg-brand-sand" data-testid="section-smart">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="eyebrow">{t("smart.eyebrow")}</div>
          <h2 className="h2 mt-4">{t("smart.title")}</h2>
          <p className="lede mt-5">{t("smart.lede")}</p>
        </div>

        {/* Tag legend */}
        <div className="mt-8 flex flex-wrap gap-2 text-[11px] font-semibold">
          {Object.entries(labels).map(([k, v]) => (
            <span key={k} className={`px-2.5 py-1 rounded-full border ${TAG_STYLES[k]}`}>
              {v}
            </span>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it, i) => {
            const Icon = ICONS[i] || Radar;
            return (
              <div
                key={i}
                className="bg-white rounded-2xl border border-brand-line p-5 flex items-start gap-4 hover:shadow-soft transition-transform duration-200 hover:-translate-y-0.5"
                data-testid={`smart-item-${i}`}
              >
                <div className="h-10 w-10 rounded-xl bg-brand-sand flex items-center justify-center text-brand-charcoal shrink-0">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-brand-charcoal leading-snug">
                    {it.t}
                  </div>
                  <span className={`mt-2 inline-flex px-2 py-0.5 rounded-full border text-[10px] font-bold uppercase tracking-wider ${TAG_STYLES[it.tag]}`}>
                    {labels[it.tag]}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
